import { Flex, Text, Tooltip } from "@/atoms"
import { isMaliciousPackageIssue } from "@/domain/issue"
import { useTranslation } from "@/hooks/useTranslation"
import { InformationAlert } from "@/molecules/InformationAlert"

import styles from "./MaliciousPackageAlert.module.scss"

import type { IssueDTO } from "@/pages/TriagePage/application/useTriage.types"

export const MaliciousPackageAlert = ({
  issue,
  className
}: {
  issue: IssueDTO
  className?: string
}) => {
  const { t } = useTranslation("translation", {
    keyPrefix: "triage.drawer.alerts.malPkg"
  })

  if (!isMaliciousPackageIssue(issue)) return null

  return (
    <InformationAlert
      className={className}
      message={
        <Flex gap={4} align="center">
          {t("line1")}
          <Tooltip rootClassName={styles.tooltip} title={t("tooltip")}>
            <Text underline>{`${t("line2")}.`}</Text>
          </Tooltip>
        </Flex>
      }
    />
  )
}
